import { FC } from 'react';

import { StateTag, Variants } from '@zazume/zzm-base';

import { useI18n } from '#/hooks/useI18n';
import { ExternalStatus } from '#/models/invoice/Invoice';

const externalStatusVariants: { [key in ExternalStatus]: Variants } = {
  pending: 'warning',
  registered: 'success',
  requiresCorrection: 'error',
  requiresInspection: 'error',
  stored: 'warning',
  invalid: 'error'
};

interface ExternalStatusTagProps {
  externalStatus: ExternalStatus;
}

export const ExternalStatusTag: FC<ExternalStatusTagProps> = ({ externalStatus }) => {
  const { t } = useI18n();

  const text = t(`invoices.externalStatuses.${externalStatus}`);

  return <StateTag variant={externalStatusVariants[externalStatus]} text={text} />;
};
